import { ChildrenType } from '../../definitions/types/Children';
import { PANEL_WIDTH } from '../../utils/constants/PANEL_WIDTH';

import { Wrap } from './styles';

interface ICollapsibleProps {
  active?: boolean;
  children?: ChildrenType;
  width?: number | 'auto';
  'data-testid'?: string;
}

export const Collapsible = ({
  active = false,
  width,
  children,
  'data-testid': dataTestid,
}: ICollapsibleProps) => {
  let maxWidth: string | number = PANEL_WIDTH;
  if (width) maxWidth = width === 'auto' ? '100%' : width;

  return (
    <Wrap
      className="collapse"
      data-testid={dataTestid || 'collapsible'}
      style={{ maxWidth: active ? maxWidth : 0 }}
    >
      {children}
    </Wrap>
  );
};
